var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutWithContainer",
    [
      _vm.$wait.is("events")
        ? _c(
            "div",
            { staticClass: "loading" },
            [_c("Spinner", { attrs: { height: 40, width: 40 } })],
            1
          )
        : [
            _vm.events
              ? _c(
                  "template",
                  { slot: "header" },
                  [
                    _c("ContentHeader", {
                      attrs: {
                        title: "Conferences Documents",
                        "back-link": "/documents",
                        "back-link-title": "Back to Documents",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "grid grid--cards" },
              [
                _vm.error
                  ? _c("li", { staticClass: "grid__error col-12" }, [
                      _c("span", { staticClass: "h2" }, [
                        _vm._v("Unable to load events."),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn--link",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.getEvents.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("Retry")]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.events.length
                  ? _vm._l(_vm.events, function (event) {
                      return _c(
                        "li",
                        { staticClass: "col-md-6 col-lg-6 col-12" },
                        [
                          _c("Card", {
                            attrs: {
                              url: `/documents/conferences/${event.id}`,
                              title: event.eventName,
                              "sub-title": event.start
                                ? event.start.displayDate
                                : null,
                              img: event.backgroundImage
                                ? event.backgroundImage
                                : null,
                            },
                          }),
                        ],
                        1
                      )
                    })
                  : _vm._e(),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }